/**
 * «Сайт и контент» (#848): чего клиент не нашёл до звонка.
 *
 * Вопросы клиентов (#843) — частые вопросы по предмету и вопросы первой
 * минуты — показываются, только когда флаг `enableCustomerQuestions` не
 * закрыт И сервер прислал `customerQuestions`, слоями (`VoiceSiteQuestions`,
 * #2072) с разделом черновика FAQ по нажатию (`VoiceFaqDraft`, §8 п. 6). Закрыто (карта флагов
 * ответила «нет» или сервер ответил без блоков) — пояснение без выдуманных
 * чисел (решение владельца 28.09); карта не ответила — решает сервер. Темы
 * разговоров (#845 PR 6) — за своим флагом, от вопросов не зависят: раздел
 * «Темы» вкладки (`VoiceSiteQuestions`) или блок под пояснением
 * (`VoiceSiteClosed`, там же панель фильтров).
 */
import { VoiceLoading } from './VoiceLoading';
import { VoiceSiteClosed } from './VoiceSiteClosed';
import { VoiceSiteQuestions, type VoiceSiteQuestionsProps } from './VoiceSiteQuestions';

/**
 * Where `enableCustomerQuestions` stands on the client:
 * - `on` / `off` — a positive answer: the server's verdict in the flag map,
 *   or the Bitrix24 session's flag list;
 * - `upgrade` — the verdict says the plan is below the blocks' floor: a plan
 *   matter, said with the plan, not «switched off»;
 * - `loading` — no answer yet (the localStorage seed is not one);
 * - `unknown` — the map failed or came back degraded: it reads every flag as
 *   off, which is not an answer — the tabs ask the server, which decides.
 */
export type QuestionsSwitch = 'on' | 'off' | 'upgrade' | 'loading' | 'unknown';

interface VoiceSiteTabProps extends VoiceSiteQuestionsProps {
  questionsSwitch: QuestionsSwitch;
}

/**
 * «Switched off for your organization» only on a positive closed signal: the
 * flag map's answer here, or the server's closed answer inside
 * `VoiceSiteQuestions`. Never from a map that is still loading or failed.
 */
export function VoiceSiteTab({ questionsSwitch, ...props }: VoiceSiteTabProps) {
  if (questionsSwitch === 'off' || questionsSwitch === 'upgrade') {
    return <VoiceSiteClosed reason={questionsSwitch} {...props} />;
  }
  if (questionsSwitch === 'loading') return <VoiceLoading />;
  return <VoiceSiteQuestions {...props} />;
}
